import RequestClass from '@api/request/RequestClass';
import {API_NAMESPACE} from '@constants/general';
import {METHOD_POST} from '@constants/http';
import type {FeedbackFormItem} from '@interfaces/FeedbackItem';
import type {EmptyRestApiResponse} from '@interfaces/RestApiResponse';

export async function sendFeedback(
    title: string,
    pageUrl: string,
    feedbackFormData: FeedbackFormItem[],
): Promise<EmptyRestApiResponse> {
    return (await new RequestClass(`${API_NAMESPACE}/feedback`, METHOD_POST)
        .setParams({
            title,
            url: pageUrl,
            items: feedbackFormData,
        })
        .send()) as Promise<EmptyRestApiResponse>;
}
